import { ChangeEventHandler, FC } from 'react';

import { Input } from 'ui/components';
import { cn } from 'utils/helpers';
import { BsXLg } from 'react-icons/bs';
import { debounce } from 'lodash';
import { Combobox } from '@headlessui/react';

interface OPTIONS_PROPS {
  label: JSX.Element;
  value: any;
}

interface PROPS {
  options: OPTIONS_PROPS[];
  onChange: (query: string) => void;
  onClickItem: (opt: OPTIONS_PROPS) => void;
  onClickClear: () => void;
  optionsClassname?: string;
}

const EmailInviteAutocomplete: FC<PROPS> = ({
  options,
  onChange,
  onClickItem,
  onClickClear,
  optionsClassname,
}) => {
  const handleOnChange: ChangeEventHandler<HTMLInputElement> = debounce(
    (evt) => {
      onChange(evt.target.value);
    },
    500,
  );

  const handleSelect = (selectedItem: OPTIONS_PROPS) => {
    onChange?.(
      typeof selectedItem.label === 'string' ? selectedItem.label : '',
    );
    onClickItem?.(selectedItem);
  };

  const handleClearInput = () => {
    onClickClear();
  };

  return (
    <div className={cn('group', 'relative w-full')}>
      <Combobox onChange={(value: OPTIONS_PROPS) => handleSelect(value)}>
        <Combobox.Input
          as={Input}
          onChange={handleOnChange}
          placeholder="Search email"
          addon={{
            icon: BsXLg,
            onClick: handleClearInput,
            className: 'text-content hover:text-danger-base transition',
            tooltip: 'Clear',
          }}
        />
        <Combobox.Options
          as="ul"
          className={cn(
            'mt-2 w-full',
            'bg-fill-tertiary',
            'absolute z-20 top-full',
            'max-h-60 overflow-y-scroll scrollbar-thin',
            optionsClassname,
            'shadow-leapify-sm',
          )}
        >
          {options.map((item, index) => (
            <Combobox.Option
              key={`${item.value}_${index}`}
              value={item}
              onClick={() => handleSelect(item)}
              className={({ active }) =>
                cn('flex items-center px-4 py-2', { 'bg-fill-primary': active })
              }
            >
              {item.label}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </Combobox>
    </div>
  );
};

export default EmailInviteAutocomplete;
